import { StyleSheet, Dimensions } from 'react-native'

const { width } = Dimensions.get('window')

export default StyleSheet.create({
  cardContainer: theme => ({
    padding: 15,
    marginBottom: 16,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 6,
    shadowOpacity: 1,
    elevation: 2,
    width: Dimensions.get('window').width > 700 ? (width - 300) * 0.8 : width - 32,
    marginRight: 8.5,
    marginTop: 20,
    height: 550,
  }),
})
